import { resolvePath } from 'react-router-dom'

const MIDDLE_MOUSE_BUTTON = 1
const NEW_TAB_TARGET = '_blank'
const NEW_TAB_FEATURES = 'noopener'

export type NewTabClickEvent = {
  button: number
  metaKey: boolean
  ctrlKey: boolean
  shiftKey: boolean
}

type LinkClickEvent = NewTabClickEvent & {
  defaultPrevented: boolean
  preventDefault: () => void
}

export const isNewTabClick = (event?: NewTabClickEvent | null): boolean =>
  !!event &&
  (event.metaKey || event.ctrlKey || event.shiftKey || event.button === MIDDLE_MOUSE_BUTTON)

export const isClickOnNestedLink = (event: { target: EventTarget | null }): boolean =>
  event.target instanceof Element && event.target.closest('a[href]') !== null

export const resolveAppPath = (to: string, fromPathname: string): string => {
  const { pathname, search, hash } = resolvePath(to, fromPathname)
  return `${pathname}${search}${hash}`
}

export const openInNewTab = (href: string): void => {
  window.open(href, NEW_TAB_TARGET, NEW_TAB_FEATURES)
}

export const navigateOrOpenInNewTab = (
  event: NewTabClickEvent | null | undefined,
  href: string,
  navigateInApp: () => void
): void => {
  if (isNewTabClick(event)) {
    openInNewTab(href)
    return
  }
  navigateInApp()
}

export const handleLinkClick = (event: LinkClickEvent, navigateInApp: () => void): void => {
  if (event.defaultPrevented || isNewTabClick(event)) {
    return
  }
  event.preventDefault()
  navigateInApp()
}
